import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/domains';
export var FIND_GLOBAL_FORMS_USE_CASE = 'FIND_GLOBAL_FORMS_USE_CASE';
export var FindGlobalFormsQueryUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(FindGlobalFormsQueryUseCase, _UseCase);

  var _super = _createSuper(FindGlobalFormsQueryUseCase);

  function FindGlobalFormsQueryUseCase(globalFormRepository) {
    var _this;

    _classCallCheck(this, FindGlobalFormsQueryUseCase);

    _this = _super.call(this);
    _this.globalFormRepository = globalFormRepository;
    return _this;
  }

  _createClass(FindGlobalFormsQueryUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var globalFormsOrError, _globalFormsOrError$g, globalForms, nextToken;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.globalFormRepository.findMany(input);

              case 2:
                globalFormsOrError = _context.sent;

                if (!globalFormsOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Result.fail(globalFormsOrError.error));

              case 5:
                _globalFormsOrError$g = globalFormsOrError.getValue(), globalForms = _globalFormsOrError$g.globalForms, nextToken = _globalFormsOrError$g.nextToken;
                return _context.abrupt("return", Result.ok({
                  globalForms: globalForms,
                  nextToken: nextToken
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return FindGlobalFormsQueryUseCase;
}(UseCase);